import { Form, Formik } from 'formik'
import React, { useState, useEffect } from 'react'
import { AudioContainer, Container, FormContainer } from './Styled'
import { Input } from 'formik-antd'
import AudioPlayer from '../../statistic/transcription/audioPlayer/AudioPlayer'
import { Button, Alert, message } from 'antd'
import Loader from '../../system/loader/Loader'
import { env } from '../../../helpers/env'

type TtsManagerProps = {}

const TtsManager: React.FunctionComponent<TtsManagerProps> = (props) => {
    const [waveForm, setWaveform] = useState<WaveSurfer | undefined>(undefined)

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        console.log('waveForm', waveForm)
        if (waveForm !== undefined) {
            waveForm.on('ready', () => {
                message.success("Votre audio est prêt !");
                setIsLoading(false)
            })

            waveForm.on('error', () => {
              message.error("Oups, erreur lors de la génération de l'audio");
              setIsLoading(false)
            })

            waveForm.on('loading', (values) => {
                console.log('wave -> loading')
                if (!isLoading) setIsLoading(true)
            })
        }
    }, [waveForm])

    const handlePlay = () => {
        waveForm?.playPause()
    }
    return (
        <Container>
            <Formik
                enableReinitialize
                initialValues={{ text: '' }}
                onSubmit={(values) => {
                    waveForm!.load(
                        `${env('REACT_APP_API_URL')}/Speech/TextToSpeech?text=${
                            values.text
                        }&provider=Microsoft&voice=${env('TTS_VOICE')}`
                    )
                }}
                render={({ values, errors, touched }) => {
                    return (
                        <Form>
                            <FormContainer>
                                <Alert
                                    message="Text to speech"
                                    description="Tester vos textes en les insérant dans le champs ci-dessous pour générer"
                                    type="info"
                                />
                                <Input.TextArea
                                    style={{
                                        marginTop: '10px',
                                        height: '200px',
                                    }}
                                    name="text"
                                    rows={4}
                                />
                                <Button
                                    type="primary"
                                    loading={isLoading}
                                    htmlType="submit"
                                >
                                    Générer audio
                                </Button>
                            </FormContainer>
                        </Form>
                    )
                }}
            />
            <AudioContainer>
                <Loader isLoading={isLoading}>
                    <AudioPlayer
                        url={''}
                        className="audioPlayer"
                        isLoading={isLoading}
                        isPlaying={false}
                        onPlayPause={handlePlay}
                        setWave={setWaveform}
                    />
                </Loader>
            </AudioContainer>
        </Container>
    )
}

export default TtsManager
